export default __webpack_public_path__ + "static/media/GKLS_150.a81b0572.jpg";